var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasBox",staticClass:"amp-box w-100 h-100"},[_c('canvas',{ref:"canvas",staticClass:"canvas",on:{"click":_vm.onClickCanvas}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }